import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 173-rewind
 * @see {GlyphIcon}
 */
const RewindIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M27.99933,9.46185V22.53821a.8.8,0,0,1-1.2312.67383L16.55219,16.67383a.8.8,0,0,1,0-1.34766L26.76813,8.788A.8.8,0,0,1,27.99933,9.46185ZM14.76813,8.788,4.55219,15.32617a.8.8,0,0,0,0,1.34766L14.76813,23.212a.8.8,0,0,0,1.2312-.67383V9.46185A.8.8,0,0,0,14.76813,8.788Z";
	}
}

export default RewindIcon;